$(".icoboxspace-slider").slick({dots:!1,infinite:!1,speed:300,slidesToShow:3,slidesToScroll:3,arrows:!1,responsive:[{breakpoint:991,settings:{slidesToShow:2,slidesToScroll:2,infinite:!0,dots:!1}},{breakpoint:600,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:480,settings:{slidesToShow:2,slidesToScroll:1,infinite:!0,autoplay:!0,speed:1e3,autoplaySpeed:1e3}}]}),setInterval(function(){var headernavlinkElement=document.getElementById("headernavlink"),headernavlinkHeight=headernavlinkElement.clientHeight; var salesbarElement=document.getElementById("collectionTop");if(salesbarElement){salesbarElement.style.setProperty("--height","translateY(".concat(headernavlinkHeight,"px)"))}},100);

$('.reelUp_card_video--main').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  centerMode: false,
  centerPadding: '150px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$('.collection-top---flex').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        speed:1000,
        autoplaySpeed:1000,
        autoplay:true,
      }
    },
    {
      breakpoint: 767,
      settings: {
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed:1000,
        autoplaySpeed:1000,
        autoplay:true,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

setInterval(function () {
  var toolbarElement = document.querySelector('.toolbar');
  var toolbarHeight = toolbarElement ? toolbarElement.clientHeight : 0;
  
  var salesbarElement2 = document.querySelector('.header-section');
  if (salesbarElement2) {
    salesbarElement2.style.setProperty('--height', `${toolbarHeight}px`);
  }
}, 100);


//# sourceMappingURL=/s/files/1/0681/8509/6482/t/34/assets/custom.js.map?v=1699784581

//  $(document).ready(function () {
//   $('.reelUp_card_video--btn').on('click', function () {
//     var dataSrc = $(this).attr('datasrc');
//     console.log(dataSrc);
//     $('.reelUp_card_video--popup video').attr('src', dataSrc);
//     $('.reelUp_card_video--popup').addClass('active');
//     $('.reelUp_card_video--bgpopup').addClass('active');
//   });

//   $('.reelUp_card_video--bgpopup').on('click', function () {
//     var popupVideo = $('.reelUp_card_video--popup video');
//     popupVideo.removeAttr('src');
//     popupVideo[0].pause(); // Pause the video
//     $('.reelUp_card_video--popup').removeClass('active');
//     $('.reelUp_card_video--bgpopup').removeClass('active');
//   });
// }); 

// setInterval(function () {
//   let teeMoney = $('.price.tee-price--current span.money').text();
//   $('#teeAtcButton span').css("--cartcurrent", `${teeMoney}`);
// }, 100);

// setInterval(function () {
//   let teeMoney = document.querySelector('span.money.theme-money.price.tee-price--current').textContent;
//   let teeAtcButtonSpan = document.querySelector('#teeAtcButton span');

//   if (teeAtcButtonSpan) {
//     teeAtcButtonSpan.setAttribute('data-after-content', `- ${teeMoney}`);
//   }
// }, 100);

// product-description

// var isExpanded = false;
// var productDescription = document.getElementById('productDescription');
// var seeMoreLink = document.getElementById('seeMoreLink');

// seeMoreLink.addEventListener('click', function () {
//     if (isExpanded) {
//         productDescription.classList.remove('expanded');
//         productDescription.classList.add('collapsed');
//         seeMoreLink.textContent = 'Ver más descripción';
//     } else {
//         productDescription.classList.remove('collapsed');
//         productDescription.classList.add('expanded');
//         seeMoreLink.textContent = 'Ver menos descripción';
//     }
//     isExpanded = !isExpanded;
// });

